import { cn } from "@/lib/utils"
import classes from "./release-status-badge.module.scss"

export const ReleaseStatus = {
  TodayRelease: "today-release",
  NextRelease: "next-release",
  NewTables: "new-tables",
} as const

export type ReleaseStatus = (typeof ReleaseStatus)[keyof typeof ReleaseStatus]

const RELEASE_STATUS_LABELS: Record<ReleaseStatus, string> = {
  [ReleaseStatus.TodayRelease]: "TODAY'S RELEASE",
  [ReleaseStatus.NextRelease]: "NEXT RELEASE",
  [ReleaseStatus.NewTables]: "NEW TABLES",
}

export type ReleaseStatusBadgeProps = Readonly<{
  className?: string
  status?: ReleaseStatus
}>

export type ReleaseStatusSource = Readonly<{
  isTodayRelease?: boolean
  isNextRelease?: boolean
  isNewTableLabel?: boolean
}>

export function getReleaseStatus({
  isTodayRelease,
  isNextRelease,
  isNewTableLabel,
}: ReleaseStatusSource): ReleaseStatus | undefined {
  if (isTodayRelease) return ReleaseStatus.TodayRelease
  if (isNextRelease) return ReleaseStatus.NextRelease
  if (isNewTableLabel) return ReleaseStatus.NewTables
  return undefined
}

export function getReleaseStatusLabel(
  status?: ReleaseStatus
): string | undefined {
  return status ? RELEASE_STATUS_LABELS[status] : undefined
}

export function ReleaseStatusBadge({
  className,
  status,
}: ReleaseStatusBadgeProps) {
  const label = getReleaseStatusLabel(status)
  if (!label) return null

  return (
    <div className={cn(classes.releaseBadge, className)}>
      <span className={classes.releaseBadgeText}>{label}</span>
    </div>
  )
}
